import { render, staticRenderFns } from "./BadgeSelect.vue?vue&type=template&id=2bbb5f54&"
import script from "./BadgeSelect.vue?vue&type=script&lang=js&"
export * from "./BadgeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports